/* ELLIZ: menu/modal kapaninca hero videolarini devam ettir. 2026-06-10
   Kok neden: global.js ModalDialog.show() VE close() pauseAllMedia()
   cagiriyor (sayfadaki TUM video'lari durduruyor), resume hic yok.
   Bu betik menu drawer'i (menumodal-dialog #header-modal-mainmenu)
   gozler: .active sinifi kalkinca zarahero videolarini play eder.
   (close() .active'i 500ms sonra kaldirir, ikinci pauseAllMedia()
   cagrisindan SONRA — o yuzden bu an guvenli.)
   2026-07-17 ek: (1) hero play() reddedilirse (Dusuk Guc Modu / pil
   tasarrufu) ilk dokunusta yeniden dener; (2) ekranda gorunen KART
   videolarini da geri baslatir (pauseAllMedia kartlari da durduruyor,
   IO 'played' sinifi yuzunden kart ekrandan cikip girmeden
   kendiliginden tekrar oynamiyordu). */
(function () {
  function gestureRetry(v) {
    document.addEventListener('touchstart', function () {
      if (v.paused) { var q = v.play(); if (q && q.catch) q.catch(function () {}); }
    }, { once: true, passive: true });
  }
  function resumeVideos() {
    document.querySelectorAll('video[id^="zarahero-vid"][autoplay]').forEach(function (v) {
      if (v.paused) {
        var p = v.play();
        if (p && p.catch) p.catch(function () { gestureRetry(v); });
      }
    });
    document.querySelectorAll('.elliz-card-video video').forEach(function (v) {
      if (!v.paused) return;
      var r = v.getBoundingClientRect();
      if (r.width > 0 && r.bottom > 0 && r.top < window.innerHeight) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    });
  }
  function init() {
    var mm = document.getElementById('header-modal-mainmenu');
    if (mm) {
      new MutationObserver(function () {
        if (!mm.classList.contains('active')) resumeVideos();
      }).observe(mm, { attributes: true, attributeFilter: ['class'] });
    }
    /* Diger ModalDialog'lar (arama, popup): close() once 'modalClosed'
       yayinlar, pauseAllMedia()'yi senkron cagirir, .active 500ms sonra
       kalkar — 600ms gecikme bu pencerenin disinda, guvenli.
       (Cart drawer ModalDialog DEGIL, medya durdurmaz; kapsam disi.) */
    document.body.addEventListener('modalClosed', function () {
      setTimeout(resumeVideos, 600);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
